<template>
	<div class="xs-12">
		<file-system-submenu :bucketName="id" />

		<core-layout-content large>
			<j-card class="xs-12 bg5 mb4 p2">
				<div class="fs4 fw7 xs-12 p2">{{ $t("bucket_name") }}</div>
				<div class="fs4 xs-12 p2">{{ bucket.bucketName }}</div>

				<div class="fs4 fw7 xs-12 p2 mt6">{{ $t("provider") }}</div>
				<div class="fs4 xs-12 p2">{{ bucket.providerId }}</div>
			</j-card>
		</core-layout-content>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import FileSystemSubmenu from "../components/FileSystemSubmenu"

import { gql } from "@/api/utils.js"
import api from "@/api/gql.js"

export default {
	name: "FileSystemSettings",

	components: {
		JCard,
		CoreLayoutContent,
		FileSystemSubmenu
	},

	props: {
		// From router
		id: String
	},

	data() {
		return {
			isLoading: false,
			bucket: {
				bucketName: null,
				provider: null
			}
		}
	},

	methods: {
		async fetchBucket() {
			const query = gql`
				query fileBuckets($where: bucketWhereInput) {
					fileBuckets(where: $where) {
						bucketName
						providerId
					}
				}
			`

			this.isLoading = true
			const res = await api({
				query,
				variables: { where: { bucketName: this.id } }
			})
			this.isLoading = false

			// Check errors
			if (res.errors)
				this.$store.dispatch("showError", [res.errors?.[0]?.message])

			this.bucket = res?.data?.fileBuckets[0] || {
				bucketName: this.id,
				providerId: "N/A"
			}
		}
	},

	created() {
		this.fetchBucket()
	}
}
</script>
